import React from 'react'
import {
  DelayAction,
  AnyActionType,
  IActionComponentProps,
} from '~core/forge.type'
import { DelayInput } from '../components'
import useDispatch from '~editor/hooks/useDispatch'

interface IProps extends IActionComponentProps {
  action: DelayAction
}

export const DelayActionComponent = ({
  action,
  actions,
  activeActionGesture,
}: IProps) => {
  const dispatch = useDispatch()

  return (
    <DelayInput
      valueInMs={action.ms}
      onChange={(ms) => {
        dispatch.nodes.updateActions({
          actionGestureType: activeActionGesture,
          actions: actions.map((_a: AnyActionType) => {
            const _action = { ..._a } as DelayAction

            if (action.id === _action.id) {
              _action.ms = ms
            }

            return _action
          }),
        })
      }}
    />
  )
}

export default DelayActionComponent
